import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchTimeline, persistTimelineRowOrder } from '../lib/api';

export default function useTimelineData(selectedDate) {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadedDate, setLoadedDate] = useState(null);
  const reloadRequestIdRef = useRef(0);

  const reload = useCallback(async (dateStr = selectedDate) => {
    const requestId = reloadRequestIdRef.current + 1;
    reloadRequestIdRef.current = requestId;
    setLoading(true);
    try {
      const data = await fetchTimeline(dateStr);
      const nextWorkflows = Array.isArray(data?.workflows) ? data.workflows : [];
      if (requestId === reloadRequestIdRef.current) {
        setWorkflows(nextWorkflows);
        setLoadedDate(String(dateStr ?? ''));
      }
      return nextWorkflows;
    } finally {
      if (requestId === reloadRequestIdRef.current) {
        setLoading(false);
      }
    }
  }, [selectedDate]);

  useEffect(() => {
    void reload(selectedDate);
  }, [reload, selectedDate]);

  useEffect(() => {
    function onTimelineChanged() {
      void reload(selectedDate);
    }

    document.addEventListener('timeline:changed', onTimelineChanged);
    return () => document.removeEventListener('timeline:changed', onTimelineChanged);
  }, [reload, selectedDate]);

  const persistRowOrder = useCallback(async (items) => {
    await persistTimelineRowOrder({
      date: selectedDate,
      items,
    });
  }, [selectedDate]);

  return {
    workflows,
    setWorkflows,
    loading,
    loadedDate,
    reload,
    persistRowOrder,
  };
}
